import DevConfigLoader from 'containers/app/DevConfig/DevConfigLoader';
import { LoaderContextProvider, ToastContextProvider } from 'contexts';
import { IChildrenProps } from 'types/ChildrenProps';
import GustoMiddleware from './GustoMiddleware';

function CustomMiddleware({ children }: IChildrenProps) {
  return (
    <ToastContextProvider>
      <LoaderContextProvider>
        <DevConfigLoader />
        <GustoMiddleware>{children}</GustoMiddleware>
      </LoaderContextProvider>
    </ToastContextProvider>
  );
}

export default CustomMiddleware;
